import { CountUp } from 'countup.js';
import { gsap  } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
//import anime from 'animejs/lib/anime.es.js';

document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);
    
    window.anims = () => {
        gsap.utils.toArray(".a-fadeInChildren > *").forEach(function(section) {
            gsap.from(section, {
                scrollTrigger: {
                    trigger: section,
                    start: '-50px bottom',
                    //once: true
                    toggleActions: "play complete complete reset",
                },
                opacity: 0, 
                duration: 1,
                y: 50,
            });
        });
        
        const countUp = function() {
            const count = document.querySelectorAll('.js-countup');

            ScrollTrigger.create({
                trigger: ".c-aboutshort__countup",
                start: "top bottom",
                onEnter: function() {
                    for (let i = 0; i < count.length; i++) {
                        let demo = new CountUp(count[i], count[i].getAttribute('data-count'), { duration: 3 });
                        !demo.error ? demo.start() : false;                        
                    }
                },
                once: true
            });
        };

    
        const designSevices = ()=> {
            gsap.from(document.querySelector('.c-designservices .img-01'), {
                scrollTrigger: {
                    trigger: '.c-designservices',
                    scrub: 1,
                    start: "top bottom",
                    end: 'bottom center'
                },
                xPercent: -100
            });
            
            gsap.from(document.querySelector('.c-designservices .img-02'), {
                scrollTrigger: {
                    trigger: '.c-designservices',
                    scrub: 1,
                    start: "top bottom",
                    end: 'bottom center'
                },
                yPercent: -100
            });
            
            gsap.from(document.querySelector('.c-designservices .img-03'), {
                scrollTrigger: {
                    trigger: '.c-designservices',
                    scrub: 1,
                    start: "top bottom",
                    end: 'bottom center'
                },
                xPercent: 100
            });
            
            gsap.from(document.querySelector('.c-designservices .img-04'), {
                scrollTrigger: {
                    trigger: '.c-designservices',
                    scrub: 1,
                    start: "top bottom",
                    end: 'bottom center'
                },
                yPercent: 100
            });
        }
        
        const goTop = ()=> {
            //ScrollTrigger.matchMedia({
              //  "(min-width: 769px)": ()=> {
                    ScrollTrigger.create({
                        trigger: 'body',
                        pin: '.o-gotop',
                        start: "top top",
                        endTrigger: ".c-social",
                    });
                    
                    gsap.to(document.querySelector('.o-gotop'), {
                        scrollTrigger: {
                            trigger: '.c-hero',
                            start: "top top-="+(window.innerHeight + document.querySelector('.o-gotop').clientHeight - document.querySelector('.o-gotop').getBoundingClientRect().bottom)+'px',
                            toggleActions: "play complete complete reverse"
                        },
                        backgroundColor: '#ffffff',
                        boxShadow: 'inset 0 0 0 1px #171719',
                        color: '#171719'
                    });
              //  }
            //})
        }
        
        const goShop = ()=> {
            //ScrollTrigger.matchMedia({
              //  "(min-width: 769px)": ()=> {
                    ScrollTrigger.create({
                        trigger: 'body',
                        pin: '.o-goshop',
                        start: "top top",
                        endTrigger: ".c-social",
                        pinSpacing: false
                    });
                    
                    gsap.to(document.querySelector('.o-goshop .o-btn'), {
                        scrollTrigger: {
                            trigger: '.c-hero',
                            start: "top top-="+(window.innerHeight + document.querySelector('.o-goshop').clientHeight - document.querySelector('.o-goshop').getBoundingClientRect().bottom)+'px',
                            toggleActions: "play complete complete reverse"
                        },
                        backgroundColor: '#ffffff',
                        boxShadow: 'inset 0 0 0 1px #171719',
                        color: '#171719'
                    });
            //    }
          //  })
        }
                
        const productsOffer = ()=> {
            ScrollTrigger.matchMedia({
                "(min-width: 769px)": ()=> {
                    ScrollTrigger.batch(".c-productsoffer .o-cols__item", {
                        onEnter: elements => {
                            gsap.from(elements, {
                                autoAlpha: 0,
                                duration: .5,
                                y: 30,
                                stagger: {
                                    each: 0.2,
                                },
                            });
                        },
                        once: true
                    });
                }
            });
        };
  
        const sectionsNav = ()=> {
            let prevSection, nextSection;
            
            /*
const checkSection = function(section) {
                console.clear();
                console.log(document.getElementById(section.id));
                
                if(document.getElementById(section.id)) {
                    prevSection = document.getElementById(section.id).previousElementSibling;
                }
                
                if (document.getElementById(section.id)) {
                    nextSection = document.getElementById(section.id).nextElementSibling;
                }
                
                console.log('next: ' + nextSection.id);
            }
*/

            ScrollTrigger.matchMedia({
                "(min-width: 769px)": ()=> {
                    
                    gsap.utils.toArray(".c-sectionsnav .icon-arrow-nav").forEach(function(el) {
                        gsap.to(el, {
                            scrollTrigger: {
                                trigger: '.c-hero',
                                scrub: 1,
                                start: "top top",
                                end: "bottom center"
                            },
                            backgroundColor: '#ffffff',
                            boxShadow: 'inset 0 0 0 1px #171719',
                            color: '#171719'
                        });
                    })
                    
                   /*
 gsap.utils.toArray(".js-section").forEach(function(section) {
                        ScrollTrigger.create({
                            trigger: section,
                            start: "top bottom",
                            onToggle: self => self.isActive ? checkSection(section) : false,
                        });
                    });
*/
                }
            })
        }
        
        const topbar = () => {
            if (!document.body.classList.contains('page-home')) {
                ScrollTrigger.matchMedia({
                    "(min-width: 769px)": () => {
                        gsap.to(document.querySelector('.c-topbar'), {
                            scrollTrigger: {
                                trigger: '.o-container',
                                start: 'top top',
                                end: '+=100px',
                                scrub: 1,
                            },
                            height: '80px'
                        });
                        
                        gsap.to(document.querySelector('.c-topbar .o-logo span'), {
                            scrollTrigger: {
                                trigger: '.o-container',
                                start: 'top top',
                                end: '+=100px',
                                scrub: 1,
                            },
                            fontSize: '16px'
                        });
                    }
                });
            }            
        }       
        
        const what = ()=> {
            ScrollTrigger.matchMedia({
                "(min-width: 1025px)": ()=> {
                    ScrollTrigger.create({
                        trigger: '.article',
                        pin: true,
                        start: () => 'top ' +  document.querySelector('.c-topbar').offsetHeight + 'px',
                        end: () => "+=" + (document.querySelector('.o-grid--02').offsetHeight - document.querySelector('.o-grid--01').offsetHeight),
                    });
                    
                    ScrollTrigger.create({
                        trigger: '.o-grid--01',
                        pin: true,
                        start: 'bottom bottom',
                        end: () => "+=" + (document.querySelector('.o-grid--02').offsetHeight - document.querySelector('.o-grid--01').offsetHeight),
                    });
                }
            })
        }
        
        let from_left = document.querySelectorAll('.a-from-left');
        if (from_left.length > 0) {
            for (let i = 0; i < from_left.length; i++) {
                gsap.from(from_left[i], {
                    xPercent: -30,
                    scrollTrigger: {
                        trigger: from_left[i],
                        scrub: 1.5,
                        start: 'top bottom',
                        end: 'center 70%'
                    }, 
                });
            }
        }
        
        let from_right = document.querySelectorAll('.a-from-right');
        if (from_right.length > 0) {
            for (let i = 0; i < from_right.length; i++) {
                gsap.from(from_right[i], {
                    xPercent: 100,
                    scrollTrigger: {
                        trigger: from_right[i],
                        scrub: 1.5,
                        start: 'top bottom',
                        end: 'center 70%'
                    }, 
                });
            }
        }
        
        let from_bottom = document.querySelectorAll('.a-from-bottom');
        if (from_left.length > 0) {
            for (let i = 0; i < from_bottom.length; i++) {
                gsap.from(from_bottom[i], {
                    yPercent: -20,
                    scrollTrigger: {
                        trigger: from_bottom[i],
                        scrub: 1.5,
                        start: 'top bottom',
                        end: 'center 70%'
                    }, 
                });
            }
        }
        
        let from_top = document.querySelectorAll('.a-from-top');
        if (from_top.length > 0) {
            for (let i = 0; i < from_top.length; i++) {
                gsap.from(from_top[i], {
                    yPercent: 30,
                    scrollTrigger: {
                        trigger: from_top[i],
                        scrub: 1.5,
                        start: 'top bottom',
                        end: 'center 70%'
                    }, 
                });
            }
        }
        
        let to_bottom = document.querySelectorAll('.a-to-bottom');
        if (to_bottom.length > 0) {
            for (let i = 0; i < to_bottom.length; i++) {
                gsap.to(to_bottom[i], {
                    yPercent: 30,
                    scrollTrigger: {
                        trigger: to_bottom[i],
                        scrub: 1.5,
                        start: 'top center',
                    }, 
                });
            }
        }
        
        document.querySelector('.c-aboutshort__countup') ? countUp() : false;
        document.querySelector('.c-designservices') ? designSevices() : false;
        //document.querySelector('.c-newproduct') ? newProduct() : false;
        document.querySelector('.o-goshop') ? goShop() : false;
        document.querySelector('.o-gotop') ? goTop() : false;
        document.querySelector('.c-productsoffer') ? productsOffer() : false;
        //document.querySelector('.js-sectionsnav') ? sectionsNav() : false;
        //document.querySelector('.c-storage') ? storage() : false;
        document.querySelector('.c-topbar') ? topbar() : false;
    };

}, false)
